var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsTabDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFD74B",
    x: 12.154,
    y: 29.146,
    width: 19.077,
    height: 19.077,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.846 53.223V62.3a5 5 0 0 1-5 5H17.154a5 5 0 0 1-5-5v-9.077a5 5 0 0 1 5-5h37.692a5 5 0 0 1 5 5z",
    fill: "#37DC8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.596 40.928 52.2 45.575a5 5 0 0 1-7.265 0L21.365 20.66a5 5 0 0 1 0-6.872l4.397-4.647a5 5 0 0 1 7.264 0l23.57 24.916a5 5 0 0 1 0 6.872z",
    fill: "#5AA0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF375E",
    cx: 49.712,
    cy: 15.435,
    r: 7.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTabDashboard);
export default __webpack_public_path__ + "static/media/icons_tab_dashboard.2a9fa20157dc3b8b04d325313ce3f1d7.svg";
export { ForwardRef as ReactComponent };